export default {
  methods: {
    async undoSideEffects(props, fn) {
      const previous = props.map(prop => [ prop, this[prop] ]);

      // Note that the function need not be asynchronous
      await fn();

      await this.$nextTick();
      for (const [ prop, value ] of previous)
        this[prop] = value;
    }
  }
};
